import { Form, Formik } from "formik";
import PropTypes from "prop-types";
import React, { useRef } from "react";
import { useDispatch } from "react-redux";
import messages from "../../../assets/locale/messages";
import Input from "../../../components/Input";
import Modal from "../../../components/Modal";
import {
  addDirectorRequest,
  editDirectorRequest
} from "../../../store/Directors/actions";
import { ADD_AUTHOR_SCHEMA, EDIT_AUTHOR_SCHEMA } from "./validations";

const DirectorsForm = ({
  mode,
  selectedDirector,
  isOpen,
  lang,
  setFormModalOpen
}) => {
  const formRef = useRef();
  const dispatch = useDispatch();

  const {
    directors: {
      addTitle,
      editTitle,
      directorFirstNameLabel,
      directorSecondNameLabel,
      directorEmailLabel
    }
  } = messages[lang];

  const handleSubmit = ({ firstName, secondName, email }) => {
    const addData = {
      first_name: firstName,
      second_name: secondName,
      email
    };
    const editData = {
      first_name: firstName,
      second_name: secondName,
      id: selectedDirector?.id
    };
    mode === "add"
      ? dispatch(addDirectorRequest({ program_director: addData }))
      : dispatch(editDirectorRequest(editData));
    setFormModalOpen(false);
  };
  const handleModalSubmit = () => {
    if (formRef.current) {
      formRef.current.handleSubmit();
    }
  };

  return (
    <Modal
      title={mode === "add" ? addTitle : editTitle}
      hasActions={true}
      isOpen={isOpen}
      handleModalSubmit={handleModalSubmit}
      handleModalCancel={() => setFormModalOpen(false)}
    >
      <Formik
        initialValues={{
          firstName: selectedDirector?.first_name,
          secondName: selectedDirector?.second_name,
          email: selectedDirector?.email
        }}
        innerRef={formRef}
        onSubmit={handleSubmit}
        validationSchema={
          mode === "add" ? ADD_AUTHOR_SCHEMA : EDIT_AUTHOR_SCHEMA
        }
      >
        {() => (
          <Form>
            <Input name="firstName" label={directorFirstNameLabel} />
            <Input
              name="secondName"
              label={directorSecondNameLabel}
            />
            {mode === "add" && (
              <Input name="email" label={directorEmailLabel} />
            )}
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

DirectorsForm.propTypes = {
  mode: PropTypes.string,
  selectedDirector: PropTypes.object,
  isOpen: PropTypes.bool,
  lang: PropTypes.string,
  setFormModalOpen: PropTypes.func
};

DirectorsForm.defaultProps = {
  mode: "add",
  isOpen: false
};

export default DirectorsForm;
